/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable no-duplicate-imports */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-empty-function */
import { h } from 'preact';
import styled from 'styled-components';
import { Tabs } from 'antd-mobile';

const TabWrap: any = ({
  topCategoryList,
  list,
  handelCategoryId,
  todayCategoryId,
}: any) => {
  return (
    <Container>
      {list.length > 1 && (
        <TabOutOne>
          <TabInner className="tab-container">
            <Tabs
              activeKey={todayCategoryId}
              onChange={(val) => {
                handelCategoryId(val);
              }}
            >
              {list.map((item: any) => {
                return (
                  <Tabs.Tab title={item.category_name} key={item.category_id} />
                );
              })}
            </Tabs>
          </TabInner>
        </TabOutOne>
      )}
    </Container>
  );
};

export default TabWrap;

const Container = styled.div`
  margin-top: 24px;
  width: 702px;
  border-radius: 16px;
  background-color: #fff;
`;

const TabOutOne = styled.div`
  width: 702px;
  height: 72px;
  background: #b0a6f4;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;
const TabInner = styled.div`
  width: 682px;
  height: 60px;
  background: #ffffff;
  border-radius: 12px;
  padding: 8px 8px 0 8px;
`;
